import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';
import { Logger } from '@/idv2/utils/logger';
import parsePermissionError from './parse-permission-error';
export type CameraPermissionState = 'undetected' | 'undefined-navigator' | 'not-allowed' | 'allowed' | 'device-not-found' | 'device-busy' | 'no-video-option' | 'missing-media-devices' | 'other-error';
const PERMISSION_CHECK_INTERVAL = 100;
const useCameraPermission = () => {
  const $ = _c(2);
  const [permissionState, setPermissionState] = useState("undetected");
  const [permissionQueryPending, setPermissionQueryPending] = useState(false);
  const shouldQueryPermission = (permissionState === "undetected" || permissionState === "not-allowed") && !permissionQueryPending;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const handlePermissionError = err => {
      const error = err as DOMException;
      setPermissionState(parsePermissionError(error));
      setPermissionQueryPending(false);
      Logger.warn(`Error while retrieving camera permission. Error: ${error.name}`, {
        location: "desktop-selfie"
      });
    };
    t0 = () => {
      if (!navigator?.mediaDevices) {
        handlePermissionError({
          name: "MissingMediaDevices"
        });
        return;
      }
      navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      }).then(stream => {
        stream.getTracks().forEach(_temp);
        setPermissionState("allowed");
        setPermissionQueryPending(false);
      }).catch(handlePermissionError);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const promptPermission = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setPermissionQueryPending(true);
      if (navigator.permissions && typeof navigator.permissions.query === "function") {
        navigator.permissions.query({
          name: "camera"
        }).then(result => {
          if (result.state === "granted") {
            setPermissionState("allowed");
            return;
          }
          setPermissionState(_temp2);
          promptPermission();
        }).catch(() => {
          promptPermission();
        });
        return;
      }
      promptPermission();
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useInterval(t1, shouldQueryPermission ? PERMISSION_CHECK_INTERVAL : null);
  return permissionState;
};
export default useCameraPermission;
function _temp(track) {
  track.stop();
}
function _temp2(prev) {
  return prev === "undetected" ? "not-allowed" : prev;
}